import React, { Component } from "react";
import Menu from "./includes/Menu";
import { Grid } from "../../../node_modules/@material-ui/core";
import BusinessForexChart from "../assets/images/business-forex-chart.png";
import BusinessForexChartSC from "../assets/images/business-forex-chart-sc.png";
import BusinessForexChartEN from "../assets/images/business-forex-chart-en.png";

const lang = "";

class BusinessForex extends Component {
  constructor(props) {
    super(props);
    this.lang = props.lang ? props.lang : "";
  }

  componentDidMount() {
    document.title = this.getLangText({
      tc: "技術咨詢",
      sc: "技术咨询",
      en: "Technology Consulting"
    });
  }

  getLangText(langJson) {
    return this.lang ? langJson[this.lang] : langJson["tc"];
  }

  render() {
    return BusinessForexJSX(this);
  }
}

const BusinessForexJSX = ctx => (
  <div className={ctx.lang === "en" ? "en" : ""}>
    <Menu lang={ctx.lang} />

    <div className="main-content-container">
      <div className="main-content-inner-wrapper business">
        <Grid container spacing={0}>
          <Grid item id="page-title">
            <span>
              {ctx.getLangText({
                tc: "信息技術方案咨詢",
                sc: "信息技术方案咨询",
                en: "Information Technology Solutions Consulting"
              })}
            </span>
          </Grid>
        </Grid>
        <div style={{ clear: "both" }} />

        <div className="business-container">
          <Grid container spacing={0} className="content-container">
            <Grid item style={{ paddingBottom: "30px" }}>
              <p>
                {ctx.getLangText({
                  tc:
                    "基於微服務理念構建的系統技術架構體系，形成了統一服務體系，協助客戶全方位快速、靈活、安全的構建基於PC、移動等多形式、多渠道的互聯網應用。我們的互聯網（移動互聯網）解決方案適用於多領域的應用，具體產品或服務場景包括但不限於門戶網站系統、商城系統、權益平台、統一認證系統、用戶服務平台、營銷活動平台、消息中心系統等。",
                  sc:
                    "基于微服务理念构建的系统技术架构体系，形成了统一服务体系，协助客户全方位快速、灵活、安全的构建基于PC、移动等多形式、多渠道的互联网应用。我们的互联网（移动互联网）解决方案适用于多领域的应用，具体产品或服务场景包括但不限于门户网站系统、商城系统、权益平台、统一认证系统、用户服务平台、营销活动平台、消息中心系统等。",
                  en: `Based on the concept of microservices, the technology architecture system forms a unified service system, assisting customers to build multi-format and multi-channel internet applications for PC and mobile in a comprehensive, rapid, flexible, and safe manner.`
                })}
                {ctx.lang==="en"&&(<span>
                  <br></br>
                  Our internet (mobile internet) solutions are applicable in various areas. The actual solutions include, but are not limited to, portal systems, online store systems, equity platforms, unified authentication systems, user service platforms, marketing promotion platforms, and message centre systems.
                </span>)}
              </p>
            </Grid>

            <div className="business-chart">
              <span className="business-adv-text">
                {ctx.getLangText({
                  tc: "優勢",
                  sc: "优势",
                  en: "Advantages"
                })}
              </span>

              <Grid
                container
                spacing={0}
                justify="center"
                style={{ padding: "20px" }}
              >
                <Grid item>
                  <img
                    id="img-business-chart"
                    style={{
                      display: "inline-block",
                      verticalAlign: "middle",
                      width: "100%"
                    }}
                    src={ctx.getLangText({
                      tc: BusinessForexChart,
                      sc: BusinessForexChartSC,
                      en: BusinessForexChartEN
                    })}
                  />
                </Grid>
              </Grid>
            </div>
          </Grid>
        </div>
      </div>
    </div>
  </div>
);

export default BusinessForex;



// WEBPACK FOOTER //
// ./src/components/pages/Forex.js